<nav class="navbar nav-header container-fluid tab-bar">
    <div class="nav-menu">
        <ul class="d-flex flex-row text-heading">
            @for (t of items; track t) {
                <li routerLinkActive="active" class="me-5">
                    <a [routerLink]="t.routerLink" class="align-center manage-lots-selector">
                        <div>
                            <span [ngClass]="t.logoClass">
                                @if (t.hasBadge && t.badgeNumber != null && t.badgeNumber > 0) {
                                    <span class="badge rounded-pill start-65">{{ t.badgeNumber }}</span>
                                }
                            </span>
                        </div>
                        {{ t.title }}
                    </a>
                </li>
            }
        </ul>
    </div>
</nav>
